import axios from 'axios'
import {LoginResponse} from '../types/hooks/auth'

const { REACT_APP_MASTERDATAS_API_URL } = process.env

export interface Divisiondirector {
    id: string
    divisiondirector_id: string
    divisiondirector_name: string
  
 
}

const handleResponseError = (error: any) => {
    //? = protect data no value
    if(error?.response?.data?.error){
        throw error.response.data.error
    }
    throw error
}

export const requestDivisiondirectors = async(conditions: object = {},accessToken: string): Promise<Divisiondirector[]> => {
    const data:Divisiondirector[] = await axios
    .get(`${REACT_APP_MASTERDATAS_API_URL}/divisiondirectors/all?access_token=${accessToken}`,{
        // headers: {
        //     Authorization: `Bearer ${accessToken}`
        // }
    })
    .then(response => response.data)
    .catch(error => handleResponseError(error))

    return data
}

